import React, { useCallback, useState } from "react";

export type ModalProps = {
  openModal: boolean;
  setOpenModal: (value: ((prevState: boolean) => boolean) | boolean) => void;
  onClose: (
    event?:
      | React.MouseEvent<HTMLButtonElement>
      | React.MouseEvent<HTMLAnchorElement>,
  ) => void;
  onOpen: (event?: any) => void;
};

export const useModal = (): ModalProps => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const onClose = (
    event?:
      | React.MouseEvent<HTMLButtonElement>
      | React.MouseEvent<HTMLAnchorElement>,
  ) => {
    if (event) {
      event.preventDefault();
    }

    setOpenModal(false);
  };

  const onOpen = useCallback((event?: any) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    setOpenModal(true);
  }, []);

  return {
    openModal,
    setOpenModal,
    onClose,
    onOpen,
  };
};
